interface Config {
  xAxis: (typeof X_default)[];
  yAxis: (typeof Y_default)[];
  series: any[];
  tooltip?: {
    trigger?: "axis" | "item";
    formatter?: ((param: any) => string) | string;
  };
  // TODO: 增加 legend 修改上方 (顯示、隱藏)button 字體顏色
  legend?: {};
  isDarkMode?: boolean;
}

interface XY_Default {
  type?: "value" | "category" | "time" | "log";
  boundaryGap?: boolean;
  scale?: boolean;
  name?: string;
  max?: number | null | ((arg: { value: { max: number } }) => number);
  min?: number;
  data?: number[] | string[];
  nameLocation?: "center" | "start" | "middle" | "end";
  nameGap?: number;
  nameTextStyle?: {
    fontFamily: string;
    color: string;
    padding?: number[];
  };
  minInterval?: number;
  // TODO: 增加 axisLabel 修改 x , y 軸 顏色字體
  axisLabel?: {};
}

const Y_default: XY_Default = {
  type: "value",
  scale: true,
  name: "",
  max: 100,
  min: 0,
  nameLocation: "end",
  nameGap: 20,
  nameTextStyle: {
    fontFamily: "sans-serif",
    color: "gray",
    padding: [0, 20, 0, 0],
  },
  minInterval: 1,
};

const X_default: XY_Default = {
  // type: "category",
  type: "category",
  boundaryGap: true,
  data: Array.from({ length: 31 }, (_, i) => i + 1),
  name: "Date",
  nameLocation: "center",
  nameGap: 20,
};

const getYAxis = (yAxis: Config["yAxis"]) => yAxis.map((y) => ({ ...Y_default, ...y }));
const getXAxis = (xAxis: Config["xAxis"]) => xAxis.map((x) => ({ ...X_default, ...x }));

export const getConfig = ({ xAxis, yAxis, series, isDarkMode = false, ...props }: Config) => {
  const config = {
    backgroundColor: isDarkMode ? "#1f1f1f" : "#FFFFFF",
    tooltip: {
      trigger: "axis",
    },
    legend: {
      // left: "left",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "8%",
      containLabel: true,
    },
    toolbox: {
      left: "left",
      bottom: -5,
      feature: {
        saveAsImage: {
          emphasis: {
            iconStyle: {
              color: "white",
            },
          },
        },
        dataView: {
          readOnly: true,
          lang: [" ", "Back", " "],
          optionToContent: function (opt: any) {
            const axisData = opt.xAxis[0].data;
            const series = opt.series;
       
            //Table Header
            let title = "<td>Time</td>";
            series.forEach(({ name }: { name: string }) => (title += `<td>${name}</td>`));

            let table =
              '<table style="width:100%;text-align:center;border: 1px solid #333"><tbody><tr style="background:blue; color:white">' +
              title +
              "</tr>";

            //Table Data Row
            let data = "";
            axisData.forEach((_: any, index: number) => {
              let sData = "";
              series.forEach(({ data }: { data: number[] }) => (sData += `<td>${data[index] ? data[index]?.toFixed(2) : "0"}</td>`));
              data += "<tr>" + `<td>${axisData[index]}</td>` + sData + "</tr>";
            });

            table = table + data + "</tbody></table>";
            return table;
          },
          emphasis: {
            iconStyle: {
              color: "white",
            },
          },
        },
        magicType: {
          type: ["line", "bar"],
          emphasis: {
            iconStyle: {
              color: "white",
            },
          },
        },
        // dataZoom: {},
      },
    },
    dataZoom: [
      {
        type: "inside",
        show: true,
        yAxisIndex: [0, 1],
        filterMode: "none",
        // start: 100,
        // end: 100,
      },
      // {
      //   type: "inside",
      //   show: true,
      //   xAxisIndex: 0,
      // },
    ],
    xAxis: [...getXAxis(xAxis)],
    yAxis: [...getYAxis(yAxis)],
    series: series,
    ...props,
  };

  return config;
};
